import { render, staticRenderFns } from "./MainImage.vue?vue&type=template&id=24798371&scoped=true&"
import script from "./MainImage.vue?vue&type=script&lang=js&"
export * from "./MainImage.vue?vue&type=script&lang=js&"
import style0 from "./MainImage.vue?vue&type=style&index=0&id=24798371&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24798371",
  null
  
)

export default component.exports